module.exports = "/assets/data/58ce90525dbb35301caa7afd7237a520-B80.data.json";